<template>
  <div class="learning-map">
    <ProfessionalSupport></ProfessionalSupport>
    <StudyOverview></StudyOverview>
  </div>
</template>
<script>
import StudyOverview from '../../components/StudyOverview.vue'
import ProfessionalSupport from '../../components/ProfessionalSupport.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    ProfessionalSupport,
    StudyOverview,
  },
  data() {
    return {

    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.learning-map {
  padding: 12px 14px;
  box-sizing: border-box;
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/home/learningMap.vue